import { Epic } from "./Epic"
import { Goal } from "./Goal"
import { Milestone } from "./Milestone"

export interface EpicDetailsDTO {
  epic: Epic
  goal?: Goal
  milestone?: Milestone
}

export class EpicDetails {
  epic: Epic = new Epic()
  goal?: Goal
  milestone?: Milestone

  constructor(props?: Partial<EpicDetailsDTO>) {
    if (!props) return
    this.epic = props.epic ? Epic.create(props.epic) : new Epic()
    this.goal = props.goal ? new Goal(props.goal) : undefined
    this.milestone = props.milestone ? new Milestone(props.milestone) : undefined
  }
}
